Object.defineProperty(exports, "__esModule", { value: true });
var browsertracing_1 = require("./browsertracing");
exports.BrowserTracing = browsertracing_1.BrowserTracing;
var request_1 = require("./request");
exports.instrumentOutgoingRequests = request_1.instrumentOutgoingRequests;
exports.defaultRequestInstrumentationOptions = request_1.defaultRequestInstrumentationOptions;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/tracing/dist/browser/index.js
// module id = 227
// module chunks = 1